export default __webpack_public_path__ + "static/media/mg.7c70dc00.svg";